import styled from 'styled-components';

export const ProfileSettingsStyled = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  .profileSettings {
    &__selectors {
      column-gap: 8px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;
